<script setup>
import AppButton from '@/components/ui/AppButton/AppButton'
import { CHECKIN_FEED_TOOLBAR_FILTER_EDIT_BUTTON_TEST_ID } from '@/views/check-ins/jest-helpers'

defineOptions({
  name: 'CheckinsFeedFilterButton'
})

defineProps({
  active: {
    type: Boolean
  },

  editable: {
    type: Boolean
  }
})

const emit = defineEmits({
  click: null,
  edit: null
})
</script>

<template>
  <AppButton
    :class="{ 'cffb-Button-active': active, 'cffb-Button-editable': editable }"
    class="cffb-Button"
    type="tertiary-next"
    v-bind="$attrs"
    @click="emit('click')"
  >
    <span v-if="$slots.default" class="oboard-truncated-text">
      <slot />
    </span>

    <div v-if="editable" class="cffb-Button_Edit">
      <AppButton
        :data-auto-testid="CHECKIN_FEED_TOOLBAR_FILTER_EDIT_BUTTON_TEST_ID"
        :data-testid="CHECKIN_FEED_TOOLBAR_FILTER_EDIT_BUTTON_TEST_ID"
        height="24"
        icon="edit-next-black"
        remove-padding
        type="none"
        width="24"
        @click.stop="emit('edit')"
      />
    </div>
  </AppButton>
</template>

<style lang="scss" scoped>
.cffb-Button {
  flex-shrink: 0;
  min-width: 32px;
  --button-high-padding: 8px;

  &:not(&-active) {
    background-color: $grey-3-next;
  }

  &-active {
    background-color: $dark-2;
    color: $white;
  }

  &-editable {
    position: relative;
    overflow: hidden;
  }
}

.cffb-Button_Edit {
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  --before-icon-color: #{$dark-2};
  --fill-bg: #{$grey-3-next};
  background: linear-gradient(270deg, var(--fill-bg) 24px, transparent 48px);

  opacity: 0;
  pointer-events: none;

  transition: opacity $transition-fast ease-in-out;

  .cffb-Button-active & {
    --before-icon-color: #{$white};
    --fill-bg: #{$dark-2};
  }

  // .cffb-Button:hover & {
  //   opacity: 1;
  //   pointer-events: all;
  // }

  .cffb-Button-active:hover & {
    opacity: 1;
    pointer-events: all;
  }
}
</style>
